import { useCallback, useEffect, useReducer, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { getUrl, getThemeId } from '../../components/getSubjectId'
import http from '../../components/http/http'
import AboutBiomarker from '../../components/modals/AboutBiomarker'
import {
    ModalMUI
} from '../recommendations/Recommendations'
import {
    Block,
    Box
} from './SubjectForm.styles'
import ActionFooter from './components/ActionFooter'
import PrivacyConsent from './components/PrivacyConsent'
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import CircularProgress from '@mui/material/CircularProgress'
import * as pdfjsLib from 'pdfjs-dist'
import React from 'react'
import { createPortal } from 'react-dom'
import { useDropzone } from 'react-dropzone'
import {
    clearAnalysisState,
    clearTableValues,
    convertPdfToPng,
    debounceWrapper,
    generateFileHash,
    getDefatultIndicatorValues,
    getMissingBiomarkerFields,
    initHash,
    loadAnalysisState,
    loadTableValuesFromStorage,
    saveAnalysisState,
    saveTableValuesToStorage,
    translateBiomarkerName
} from '../../utils/biomarkers'
import { convertCanvasToPdf } from '../../utils/canvasToPdf'
import { BackBtn, SubjectName } from "../../components/shared/NavigationButtons"
import ContainerContent from './../../components/ContainerContent'
import { usePromStatus } from '../../components/prom/usePromStatus'
import { PromQuestionnaire } from '../../components/prom'
import { biomarkerReducer, initialBiomarkerState } from './biomarkerReducer'
import ClipboardIcon from './icons/ClipboardIcon'
import CloseButton from './icons/CloseButton'
import UndoButton from './icons/UndoButton'
import './subjectForm.css'

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.js`;




let timer: any = -1;

const Main = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { status: promStatus } = usePromStatus()
    const [showSurveyPrompt, setShowSurveyPrompt] = useState(false)
    const [selectedIndicator, setSelectedIndicator] = useState<any>({})
    const [values, setValues] = useState<any>(getDefatultIndicatorValues() || {})
    // Initialize biomarker reducer
    const [biomarkerState, dispatch] = useReducer(biomarkerReducer, initialBiomarkerState);
    const { fields: _fields } = biomarkerState;
    const userBiomarkerOptions = [
        { value: 'Hemoglobin (HGB)', label: t('biomarkerOptionHemoglobinHgb') },
        { value: 'Hematocrit (HCT)', label: t('biomarkerOptionHematocritHct') },
        { value: 'Erythrocytes (RBC)', label: t('biomarkerOptionErythrocitesRbc') },
        { value: 'Leukocytes (WBC)', label: t('biomarkerOptionLeukocytesWbc') },
        { value: 'Thrombocytes (Platelets)', label: t('biomarkerOptionPlateletsThrombocytes') },
        { value: 'MCV', label: t('biomarkerOptionMcv') },
        { value: 'MCH', label: t('biomarkerOptionMch') },
        { value: 'MCHC', label: t('biomarkerOptionMchc') },
        { value: 'RDW', label: t('biomarkerOptionRdw') },
        { value: 'Neutrophils', aliases: ['Neutro. #', 'Neutro.#', 'Neutro.'], label: t('biomarkerOptionNeutrophilsAbs') },
        { value: 'Lymphocytes', aliases: ['Lymph. #', 'Lymph.#', 'Lymph.'], label: t('biomarkerOptionLymphocytesAbs') },
        { value: 'Monocytes', label: t('biomarkerOptionMonocytesAbs') },
        { value: 'Eosinophils', label: t('biomarkerOptionEosinophilsAbs') },
        { value: 'Basophils', label: t('biomarkerOptionBasophilsAbs') },
        { value: 'Total Cholesterol', label: t('biomarkerOptionTotalCholesterol') },
        { value: 'Triglycerides', label: t('biomarkerOptionTriglycerides') },
        { value: 'HDL Cholesterol', label: t('biomarkerOptionHdl') },
        { value: 'LDL Cholesterol', label: t('biomarkerOptionLdl') },
        { value: 'HbA1c (Glycated Hemoglobin)', label: t('biomarkerOptionHba1c') }
    ];
    const [loading, setLoading] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [privacyConsent, setPrivacyConsent] = useState(false)
    const [reportConsent, setReportConsent] = useState(false)
    const [showDropzone, setShowDropzone] = useState(false)
    const DEBOUNCE_INIT_HASH_MS = 400;
    const isMobile = window.innerWidth <= 600;
    const generateUserBiomarkerObj = (field: any) => {
        return {
            "nameEn": field.name,
            "originalValue": field.value !== '' && field.value !== undefined ? Number(field.value) : null,
            "standardizedValue": field.value !== '' && field.value !== undefined ? Number(field.value) : null,
            "originalUnit": field.unit || "",
            "userAdded": true,
            "labReferenceRange": {
                "min": field.labReferenceRange?.min !== '' && field.labReferenceRange?.min !== undefined ? Number(field.labReferenceRange.min) : null,
                "max": field.labReferenceRange?.max !== '' && field.labReferenceRange?.max !== undefined ? Number(field.labReferenceRange.max) : null,
                "unit": field.unit || "",
                "originalText": ""
            }
        }
    };



    const { acceptedFiles, getRootProps, getInputProps, fileRejections, isDragActive } = useDropzone({
        accept: {
            'image/*': ['.png', '.gif', '.jpeg', '.jpg'],
            'application/pdf': ['.pdf']
        },
        multiple: true
    });
    const files = acceptedFiles.map(file => (
        <li key={file.path}>
            {file.path} - {file.size} bytes
        </li>
    ));
    const [uploadResult, setUploadResult] = useState<any>(null);
    const [isUploading, setIsUploading] = useState(false);
    const [isFileProcessed, setIsFileProcessed] = useState(false);
    const [fieldsVisible, setFieldsVisible] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [filePreviews, setFilePreviews] = useState<string[]>([]);
    const [processedFiles, setProcessedFiles] = useState<File[]>([]);
    const [isConverting, setIsConverting] = useState(false);
    const [editingPreviewIndex, setEditingPreviewIndex] = useState<number | null>(null);
    const [isEditorOpen, setIsEditorOpen] = useState(false);
    const [showPrivacyReminder, setShowPrivacyReminder] = useState(false);
    const [editorImageUrl, setEditorImageUrl] = useState<string>('');
    const [originalPageCounts, setOriginalPageCounts] = useState<number[]>([]);
    const editorAutoOpenRef = useRef(false);
    const editorCanvasRef = useRef<HTMLCanvasElement | null>(null);
    const blurredCanvasRef = useRef<HTMLCanvasElement | null>(null);
    const [dragging, setDragging] = useState(false);
    const [startPoint, setStartPoint] = useState<{ x: number; y: number } | null>(null);
    const [endPoint, setEndPoint] = useState<{ x: number; y: number } | null>(null);
    const [blurRects, setBlurRects] = useState<Array<{ x: number; y: number; w: number; h: number }>>([]);
    const [imageNaturalSize, setImageNaturalSize] = useState<{ w: number; h: number }>({ w: 0, h: 0 });
    const editorPortalTarget = typeof document !== 'undefined' ? document.body : null;

    const [isProcessError, setIsProcessError] = useState(false);
    const [hoveredCheckbox, setHoveredCheckbox] = useState<string | null>(null);
    const [showTooltip, setShowTooltip] = useState<string | null>(null);
    const tooltipTimerRef = useRef<NodeJS.Timeout | null>(null);

    const handleRowConfirmation = (indicatorId: string, confirmed: boolean) => {
        // Dispatch action to update confirmed rows
        dispatch({ type: 'TOGGLE_ROW_CONFIRMATION', indicatorId });

        // Сохраняем состояние подтверждения в localStorage
        try {
            const key = 'biomarkers_data';
            const existing = JSON.parse(localStorage.getItem(key) || '[]');

            // Находим поле по indicatorId
            const field = _fields.find((f: any) => f.indicatorId === indicatorId);
            if (field) {
                const updated = existing.map((b: any) => {
                    // Ищем биомаркер по имени поля
                    if (b.originalName === field.name || b.nameEn === field.name || b.indicatorId === indicatorId) {
                        return {
                            ...b,
                            confirmed: confirmed
                        };
                    }
                    return b;
                });
                localStorage.setItem(key, JSON.stringify(updated));
                console.log('Updated confirmed status in localStorage:', field.name, confirmed);
            }
        } catch (e) {
            console.error('Failed to update confirmed status in localStorage', e);
        }
    };

    const handleCheckboxHover = (indicatorId: string) => {
        setHoveredCheckbox(indicatorId);
        if (tooltipTimerRef.current) {
            clearTimeout(tooltipTimerRef.current);
        }
        tooltipTimerRef.current = setTimeout(() => {
            setShowTooltip(indicatorId);
        }, 600);
    };

    const handleCheckboxLeave = () => {
        setHoveredCheckbox(null);
        setShowTooltip(null);
        if (tooltipTimerRef.current) {
            clearTimeout(tooltipTimerRef.current);
            tooltipTimerRef.current = null;
        }
    };

    const allRowsConfirmed = _fields.length > 0 && _fields.every((field: any) =>
        biomarkerState.confirmedRows.has(field.indicatorId)
    );
    const canSubmitReport = fieldsVisible && allRowsConfirmed && reportConsent;
    const shouldHighlightInput = (field: any): boolean => {
        if (biomarkerState.confirmedRows.has(field.indicatorId)) return false;
        return !!field.userAdded;
    };

    const handleUpload = async (file: File, skipHashSave = false) => {
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file);
        setIsUploading(true);
        setIsProcessError(false);
        try {
            const hash = await generateFileHash(file);
            if (!skipHashSave) {
                const existingInfo = JSON.parse(localStorage.getItem('uploaded_file_info') || 'null');
                if (!existingInfo || existingInfo.hash !== hash) {
                    localStorage.setItem('uploaded_file_info', JSON.stringify({
                        fileName: file.name,
                        hash
                    }));
                }
            }
            const themeId = getThemeId();
            const result = await http.upload(`/api/lab-results/process?checkupType=BasicCheckup&themeId=${themeId}`, formData);

            const rows = result?.table || [];
            let biomarkers = rows.map((row: any[]) => ({
                originalName: row[0],
                nameEn: row[0],
                originalValue: row[1],
                standardizedValue: row[1],
                originalUnit: row[4] || '',
                standardizedUnit: row[4] || '',
                labReferenceRange: {
                    min: row[2] ?? null,
                    max: row[3] ?? null,
                    unit: row[4] || ''
                }
            }));

            if (!biomarkers.length) {
                const missingFields = getMissingBiomarkerFields([], userBiomarkerOptions);
                const missingValues: any = {};
                missingFields.forEach((f: any) => { missingValues[f.indicatorId] = '' });
                dispatch({ type: 'SET_FIELDS', fields: missingFields });
                setValues(missingValues);
                setUploadResult(null);
                setIsFileProcessed(true);
                setIsProcessError(false);
                setFieldsVisible(true);

                const missingBiomarkersData = missingFields.map((f: any) => generateUserBiomarkerObj(f));
                localStorage.setItem('biomarkers_data', JSON.stringify(missingBiomarkersData));

                const stateToSave = {
                    fields: missingFields,
                    values: missingValues,
                    uploadResult: null,
                    isFileProcessed: true,
                    fieldsVisible: true,
                    isProcessError: false,
                    privacyConsent: privacyConsent,
                    reportConsent: reportConsent,
                    showDropzone: showDropzone
                };
                saveAnalysisState(stateToSave);

                return;
            }
            const serverFields = biomarkers.map((bm: any, idx: number) => ({
                indicatorId: idx,
                name: bm.originalName || bm.nameEn,
                value: bm.originalValue ?? bm.standardizedValue,
                unit: bm.originalUnit || bm.standardizedUnit,
                interpretation: bm.interpretation,
                confidence: bm.confidence,
                labReferenceRange: bm.labReferenceRange
            }));
            const missingFields = getMissingBiomarkerFields(biomarkers, userBiomarkerOptions);
            const allFields = [...serverFields, ...missingFields];
            const allValues: any = {};
            allFields.forEach((f: any) => { allValues[f.indicatorId] = f.value !== undefined && f.value !== '' ? f.value : '' });
            dispatch({ type: 'SET_FIELDS', fields: allFields });
            setValues(allValues);
            setUploadResult({ biomarkers });

            const missingBiomarkersData = missingFields.map((f: any) => generateUserBiomarkerObj(f));
            const allBiomarkersData = [...biomarkers, ...missingBiomarkersData];
            localStorage.setItem('biomarkers_data', JSON.stringify(allBiomarkersData));
            console.log('Biomarkers saved to localStorage:', allBiomarkersData);

            setIsFileProcessed(true);
            setFieldsVisible(true);

            const stateToSave = {
                fields: allFields,
                values: allValues,
                uploadResult: { biomarkers },
                isFileProcessed: true,
                fieldsVisible: true,
                isProcessError: false,
                privacyConsent: privacyConsent,
                reportConsent: reportConsent,
                showDropzone: showDropzone
            };

            saveAnalysisState(stateToSave);
        } catch (e) {
            alert('Upload error: ' + e);
            setIsFileProcessed(false);
            setIsProcessError(true);
        } finally {
            setIsUploading(false);
        }
    };

    const closeEditor = () => {
        setIsEditorOpen(false);
        setDragging(false);
        setStartPoint(null);
        setEndPoint(null);
        setBlurRects([]);
        setShowPrivacyReminder(true);
        setBlurRects([]);
        setShowPrivacyReminder(false);
    };

    function applySafariBlur(canvas: HTMLCanvasElement, radius: number) {
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < radius; i++) {
            boxBlur(data, canvas.width, canvas.height, 1);
        }

        ctx.putImageData(imageData, 0, 0);
    }

    function boxBlur(data: Uint8ClampedArray, width: number, height: number, radius: number) {
        const newData = new Uint8ClampedArray(data);

        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                let r = 0, g = 0, b = 0, a = 0, count = 0;

                for (let dy = -radius; dy <= radius; dy++) {
                    for (let dx = -radius; dx <= radius; dx++) {
                        const nx = x + dx;
                        const ny = y + dy;

                        if (nx >= 0 && nx < width && ny >= 0 && ny < height) {
                            const idx = (ny * width + nx) * 4;
                            r += data[idx];
                            g += data[idx + 1];
                            b += data[idx + 2];
                            a += data[idx + 3];
                            count++;
                        }
                    }
                }

                const idx = (y * width + x) * 4;
                newData[idx] = r / count;
                newData[idx + 1] = g / count;
                newData[idx + 2] = b / count;
                newData[idx + 3] = a / count;
            }
        }

        // Копируем результат обратно
        for (let i = 0; i < data.length; i++) {
            data[i] = newData[i];
        }
    }

    const handleEditorImageLoad = () => {
        const canvas = editorCanvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        const img = new Image();
        img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
            setImageNaturalSize({ w: img.width, h: img.height });
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            const blurred = document.createElement('canvas');
            blurred.width = img.width;
            blurred.height = img.height;
            const bctx = blurred.getContext('2d');
            if (bctx) {
                if (typeof bctx.filter !== 'undefined') {
                    bctx.filter = 'blur(30px)';
                    bctx.drawImage(img, 0, 0, img.width, img.height);
                } else {
                    bctx.drawImage(img, 0, 0, img.width, img.height);
                    applySafariBlur(blurred, 50);
                }
                blurredCanvasRef.current = blurred;
            }
        };
        img.src = editorImageUrl;
    };

    const onCanvasMouseDown = (e: React.MouseEvent<HTMLCanvasElement>) => {
        const canvas = e.target as HTMLCanvasElement;
        const rect = canvas.getBoundingClientRect();
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;
        const x = (e.clientX - rect.left) * scaleX;
        const y = (e.clientY - rect.top) * scaleY;
        setStartPoint({ x, y });
        setEndPoint({ x, y });
        setDragging(true);
    };

    const onCanvasMouseMove = (e: React.MouseEvent<HTMLCanvasElement>) => {
        if (!dragging || !startPoint) return;
        const canvas = editorCanvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        const rect = (e.target as HTMLCanvasElement).getBoundingClientRect();
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;
        const x = (e.clientX - rect.left) * scaleX;
        const y = (e.clientY - rect.top) * scaleY;
        setEndPoint({ x, y });
        const img = new Image();
        img.onload = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            // Draw existing blurred rectangles
            if (blurRects.length && blurredCanvasRef.current) {
                blurRects.forEach(r => {
                    if (r.w > 0 && r.h > 0) {
                        ctx.drawImage(
                            blurredCanvasRef.current as HTMLCanvasElement,
                            r.x, r.y, r.w, r.h,
                            r.x, r.y, r.w, r.h
                        );
                        ctx.strokeStyle = '#3BAAB0';
                        ctx.lineWidth = 2;
                        ctx.setLineDash([6, 4]);
                        ctx.strokeRect(r.x, r.y, r.w, r.h);
                        ctx.setLineDash([]);
                    }
                });
            }
            // Draw current selection preview as blurred
            if (startPoint && endPoint) {
                const sx = Math.min(startPoint.x, x);
                const sy = Math.min(startPoint.y, y);
                const sw = Math.abs(x - startPoint.x);
                const sh = Math.abs(y - startPoint.y);
                if (sw > 0 && sh > 0 && blurredCanvasRef.current) {
                    ctx.drawImage(
                        blurredCanvasRef.current,
                        sx, sy, sw, sh,
                        sx, sy, sw, sh
                    );
                }
                ctx.strokeStyle = '#3BAAB0';
                ctx.lineWidth = 2;
                ctx.setLineDash([6, 4]);
                ctx.strokeRect(sx, sy, sw, sh);
                ctx.setLineDash([]);
            }
        };
        img.src = editorImageUrl;
    };

    const onCanvasMouseUp = () => {
        setDragging(false);
        if (startPoint && endPoint) {
            const sx = Math.min(startPoint.x, endPoint.x || startPoint.x);
            const sy = Math.min(startPoint.y, endPoint.y || startPoint.y);
            const sw = Math.abs((endPoint?.x || startPoint.x) - startPoint.x);
            const sh = Math.abs((endPoint?.y || startPoint.y) - startPoint.y);
            if (sw > 0 && sh > 0) {
                setBlurRects(prev => [...prev, { x: sx, y: sy, w: sw, h: sh }]);
            }
        }
        setStartPoint(null);
        setEndPoint(null);
    };

    /**
     * Generates a PDF from the editor canvas and uploads it
     */
    const generateAndUploadPdf = async () => {
        if (editingPreviewIndex === null) return;
        const canvas = editorCanvasRef.current;
        if (!canvas) return;

        // Get the original page count for this file
        const pageCount = originalPageCounts[editingPreviewIndex] || 1;

        try {
            // Convert canvas to PDF
            const pdfBlob = await convertCanvasToPdf(canvas, pageCount);

            // Create a new file with PDF extension
            const oldFile = processedFiles[editingPreviewIndex];
            const newFileName = oldFile.name.replace(/\.(png|jpg|jpeg|pdf)$/i, '.pdf');
            const pdfFile = new File([pdfBlob], newFileName, { type: 'application/pdf' });

            // Update the processed files with the PDF
            const newProcessed = [...processedFiles];
            const newPreviews = [...filePreviews];
            if (newPreviews[editingPreviewIndex]) {
                URL.revokeObjectURL(newPreviews[editingPreviewIndex]);
            }
            newProcessed[editingPreviewIndex] = pdfFile;
            newPreviews[editingPreviewIndex] = URL.createObjectURL(pdfBlob);
            setProcessedFiles(newProcessed);
            setFilePreviews(newPreviews);

            closeEditor();
            await handleUpload(pdfFile, true);
        } catch (error) {
            console.error('Error generating PDF:', error);
            alert('Failed to generate PDF. Please try again.');
        }
    };

    const redrawEditorCanvas = useCallback((rectangles: Array<{ x: number; y: number; w: number; h: number }>) => {
        const canvas = editorCanvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        const img = new Image();
        img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            if (rectangles.length && blurredCanvasRef.current) {
                rectangles.forEach(r => {
                    if (r.w > 0 && r.h > 0) {
                        ctx.drawImage(
                            blurredCanvasRef.current as HTMLCanvasElement,
                            r.x, r.y, r.w, r.h,
                            r.x, r.y, r.w, r.h
                        );
                        ctx.strokeStyle = '#3BAAB0';
                        ctx.lineWidth = 2;
                        ctx.setLineDash([6, 4]);
                        ctx.strokeRect(r.x, r.y, r.w, r.h);
                        ctx.setLineDash([]);
                    }
                });
            }
        };
        img.src = editorImageUrl;
    }, [editorImageUrl]);

    const resetEditorSelections = () => {
        setBlurRects([]);
        setStartPoint(null);
        setEndPoint(null);
        redrawEditorCanvas([]);
    };

    const undoLastSelection = () => {
        setBlurRects(prev => {
            if (prev.length === 0) return prev;
            const next = prev.slice(0, -1);
            redrawEditorCanvas(next);
            return next;
        });
    };

    useEffect(() => {
        if (privacyConsent) {
            const timer = setTimeout(() => {
                setShowDropzone(true);
            }, 300);

            return () => clearTimeout(timer);
        } else {
            setShowDropzone(false);
        }
    }, [privacyConsent]);

    useEffect(() => {
        let cancelled = false;
        const prepareFiles = async () => {
            editorAutoOpenRef.current = false;
            if (!acceptedFiles || acceptedFiles.length === 0) {
                setSelectedFiles([]);
                setProcessedFiles([]);
                setFilePreviews(prev => {
                    prev.forEach(url => {
                        if (url) URL.revokeObjectURL(url);
                    });
                    return [];
                });
                setIsConverting(false);
                return;
            }

            setIsConverting(true);
            setIsProcessError(false);
            setSelectedFiles([...acceptedFiles] as File[]);
            setIsFileProcessed(false);
            setFieldsVisible(false);

            const createdPreviews: string[] = [];
            const convertedFiles: File[] = [];
            const pageCounts: number[] = [];

            try {
                for (const file of acceptedFiles) {
                    if (cancelled) break;

                    if (file.type === 'application/pdf') {
                        const { file: converted, pageCount } = await convertPdfToPng(file);
                        if (cancelled) break;
                        convertedFiles.push(converted);
                        createdPreviews.push(URL.createObjectURL(converted));
                        pageCounts.push(pageCount);
                    } else {
                        convertedFiles.push(file);
                        createdPreviews.push(URL.createObjectURL(file));
                        pageCounts.push(1); // Non-PDF files are treated as single page
                    }
                }

                if (cancelled) {
                    createdPreviews.forEach(url => URL.revokeObjectURL(url));
                    return;
                }

                setProcessedFiles(convertedFiles);
                setOriginalPageCounts(pageCounts);
                setFilePreviews(prev => {
                    prev.forEach(url => {
                        if (url) URL.revokeObjectURL(url);
                    });
                    return createdPreviews;
                });
            } catch (error) {
                console.error('Failed to prepare files', error);
                if (!cancelled) {
                    setIsProcessError(true);
                    setProcessedFiles([]);
                    createdPreviews.forEach(url => URL.revokeObjectURL(url));
                }
            } finally {
                if (!cancelled) {
                    setIsConverting(false);
                }
            }
        };

        prepareFiles();

        return () => {
            cancelled = true;
        };
    }, [acceptedFiles]);

    useEffect(() => {
        if (!editorAutoOpenRef.current && filePreviews.length > 0) {
            setEditingPreviewIndex(0);
            setEditorImageUrl(filePreviews[0]);
            setBlurRects([]);
            setIsEditorOpen(true);
            setShowPrivacyReminder(true);
            editorAutoOpenRef.current = true;
        }
    }, [filePreviews]);

    useEffect(() => {
        return () => {
            filePreviews.forEach(u => {
                if (u) URL.revokeObjectURL(u);
            });
        };
    }, [filePreviews]);

    useEffect(() => {
        const savedState = loadAnalysisState();
        const savedTableValues = loadTableValuesFromStorage();

        if (savedState) {
            console.log('Restoring analysis state:', savedState);
            console.log('🔍 isFileProcessed from saved state:', savedState.isFileProcessed);
            console.log('🔍 fieldsVisible from saved state:', savedState.fieldsVisible);
            console.log('🔍 fields length:', savedState.fields?.length);
            dispatch({ type: 'SET_FIELDS', fields: savedState.fields || [] });
            setValues(savedState.values || {});
            setUploadResult(savedState.uploadResult || null);
            setIsFileProcessed(savedState.isFileProcessed);
            setFieldsVisible(savedState.fieldsVisible);
            setIsProcessError(savedState.isProcessError || false);
            setPrivacyConsent(savedState.privacyConsent || false);
            setReportConsent(savedState.reportConsent || false);
            setShowDropzone(savedState.showDropzone || false);
        }

        try {
            const biomarkersData = localStorage.getItem('biomarkers_data');
            if (biomarkersData) {
                const biomarkers = JSON.parse(biomarkersData);
                console.log('Restored biomarkers from localStorage:', biomarkers);

                if (biomarkers && biomarkers.length > 0 && !savedState?.isFileProcessed) {
                    console.log('🔧 Auto-setting isFileProcessed to true based on biomarkers data');
                    setIsFileProcessed(true);
                    setFieldsVisible(true);
                }

                const userBiomarkers = biomarkers.filter((b: any) => b.userAdded && b.nameEn);

                if (userBiomarkers.length > 0) {
                    const userFields = userBiomarkers.map((bm: any, idx: number) => ({
                        indicatorId: `u${Date.now()}_${idx}`,
                        name: bm.nameEn,
                        value: bm.originalValue || '',
                        unit: bm.originalUnit || '',
                        labReferenceRange: bm.labReferenceRange,
                        userAdded: true,
                    }));

                    const userValues: any = {};
                    userFields.forEach((f: any) => { userValues[f.indicatorId] = f.value });

                    // Check if user biomarkers already exist
                    const existingUserFields = _fields.filter(f => f.userAdded);
                    if (existingUserFields.length === 0) {
                        dispatch({ type: 'SET_FIELDS', fields: [..._fields, ...userFields] });
                        console.log('User biomarkers restored');
                    } else {
                        console.log('User biomarkers already exist, skipping restoration');
                    }
                    setValues((prev: any) => ({ ...prev, ...userValues }));
                    setFieldsVisible(true);
                }

            }
        } catch (e) {
            console.error('Failed to restore user biomarkers', e);
        }

        if (savedTableValues && savedTableValues.fields && savedTableValues.values) {
            console.log('Restoring table values from localStorage:', savedTableValues);
            dispatch({ type: 'SET_FIELDS', fields: savedTableValues.fields });
            setValues(savedTableValues.values);
        }
    }, []);

    useEffect(() => {
        if (_fields.length > 0) {
            try {
                const biomarkersData = localStorage.getItem('biomarkers_data');
                if (biomarkersData) {
                    const biomarkers = JSON.parse(biomarkersData);
                    const confirmedIds = new Set<string>();

                    biomarkers.forEach((bm: any) => {
                        if (bm.confirmed) {
                            const matchingField = _fields.find((field: any) =>
                                field.name === bm.originalName ||
                                field.name === bm.nameEn ||
                                field.indicatorId === bm.indicatorId
                            );
                            if (matchingField) {
                                confirmedIds.add(matchingField.indicatorId);
                                console.log('Found matching field for confirmed biomarker:', bm.originalName || bm.nameEn, '->', matchingField.indicatorId);
                            } else {
                                console.log('No matching field found for confirmed biomarker:', bm.originalName || bm.nameEn, 'Available fields:', _fields.map((f: any) => f.name));
                            }
                        }
                    });

                    dispatch({ type: 'SET_CONFIRMED_ROWS', confirmedRows: confirmedIds });
                    console.log('Restored confirmed rows from localStorage:', confirmedIds);
                }
            } catch (e) {
                console.error('Failed to restore confirmed rows', e);
            }
        }
    }, [_fields]);

    useEffect(() => {
        if (isMobile && fieldsVisible && _fields.length > 0) {
            const timer = setTimeout(() => {
                const resultsBlock = document.querySelector('[data-results-block]');
                if (resultsBlock) {
                    console.log('Scrolling to results block...');
                    resultsBlock.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                } else {
                    console.log('Results block not found');
                }
            }, 500);

            return () => clearTimeout(timer);
        }
    }, [isMobile, fieldsVisible, _fields.length]);

    const handleResetUpload = () => {
        setUploadResult(null);
        setIsFileProcessed(false);
        dispatch({ type: 'RESET_FIELDS' });
        setValues(getDefatultIndicatorValues() || {});
        setFieldsVisible(false);
        setIsProcessError(false);
        setShowDropzone(true);
        setReportConsent(false);
        setSelectedFiles([]);
        setProcessedFiles([]);
        setFilePreviews(prev => {
            prev.forEach(url => {
                if (url) URL.revokeObjectURL(url);
            });
            return [];
        });
        setIsConverting(false);

        clearAnalysisState();
        clearTableValues();

        localStorage.removeItem('biomarkers_data');
    };

    let fields: any[] = [];
    useEffect(() => {
        values.gender = values.gender || 'w'
        let { gender, race, age, theme } = values;
        if (!theme) {
            return navigate('/home')
        }
        setLoading(true)
    }, [])

    const onSetFields = (fields: any[]) => {
        dispatch({ type: 'SET_FIELDS', fields: [...fields] });
        Object.keys(values).map((key: any) => {
            if (!key || key == 'undefined') {
                delete values[key]
            }
            if (Number(key)) {
                let el = fields.find(it => it.indicatorId == key)
                if (!el) {
                    delete values[key]
                }
            }
        })

        setValues({ ...values })

        if (fieldsVisible && fields.length > 0) {
            const stateToSave = {
                fields: [...fields],
                values: { ...values },
                uploadResult: uploadResult,
                isFileProcessed: isFileProcessed,
                fieldsVisible: fieldsVisible,
                isProcessError: isProcessError,
                privacyConsent: privacyConsent,
                reportConsent: reportConsent,
                showDropzone: showDropzone
            };
            console.log('💾 Saving state after onSetFields:', stateToSave);
            console.log('📊 Fields with values:', fields.map((f: any) => ({ id: f.indicatorId, value: f.value, unit: f.unit })));
            saveAnalysisState(stateToSave);

            saveTableValuesToStorage([...fields], { ...values });
        }

        debounceWrapper(() => {
            initHash(fields, navigate, values)
        }, DEBOUNCE_INIT_HASH_MS, 'subjectForm')

    }

    function handleCloseModal() {
        setIsModalOpen(false)
    }

    const collectAllBiomarkersData = () => {
    const allFields = _fields.map((field: any) => ({
        nameEn: field.name,
        originalName: field.name,
        standardizedValue: values[field.indicatorId] !== undefined && values[field.indicatorId] !== '' ? Number(values[field.indicatorId]) : null,
        originalValue: values[field.indicatorId] !== undefined && values[field.indicatorId] !== '' ? Number(values[field.indicatorId]) : null,
        standardizedUnit: field.unit || '',
        originalUnit: field.unit || '',
        userAdded: field.userAdded || false,
        labReferenceRange: {
            min: field.labReferenceRange?.min !== undefined && field.labReferenceRange?.min !== '' ? Number(field.labReferenceRange.min) : null,
            max: field.labReferenceRange?.max !== undefined && field.labReferenceRange?.max !== '' ? Number(field.labReferenceRange.max) : null,
            unit: field.unit || '',
            originalText: ''
        },
        confirmed: biomarkerState.confirmedRows.has(field.indicatorId)
    })).filter((bm: any) => bm.nameEn);

    return allFields;
};

const saveUserBiomarkersToStorage = () => {
    const userBiomarkers = _fields
        .filter((field: any) => field.userAdded && field.name)
        .map((field: any) => generateUserBiomarkerObj(field));

    if (userBiomarkers.length > 0) {
        try {
            const key = 'biomarkers_data';
            const existing = JSON.parse(localStorage.getItem(key) || '[]');
            const withoutUser = existing.filter((b: any) => !b.userAdded);

            const updatedUserBiomarkers = userBiomarkers.map((userBm: any) => {
                const existingBm = existing.find((b: any) => b.userAdded && b.nameEn === userBm.nameEn);
                if (existingBm) {
                    return {
                        ...existingBm,
                        originalValue: userBm.originalValue,
                        standardizedValue: userBm.standardizedValue,
                        labReferenceRange: userBm.labReferenceRange
                    };
                }
                return userBm;
            });

            const updated = [...withoutUser, ...updatedUserBiomarkers];
            localStorage.setItem(key, JSON.stringify(updated));
            console.log('Saved user biomarkers to storage:', updatedUserBiomarkers);
        } catch (e) {
            console.error('Failed to save user biomarkers', e);
        }
    } else {
            // Если пользовательских биомаркеров нет, удаляем их из localStorage
            try {
                const key = 'biomarkers_data';
                const existing = JSON.parse(localStorage.getItem(key) || '[]');
                const withoutUser = existing.filter((b: any) => !b.userAdded);
                localStorage.setItem(key, JSON.stringify(withoutUser));
                console.log('Removed user biomarkers from storage');
            } catch (e) {
                console.error('Failed to remove user biomarkers', e);
            }
        }
    };

    return (
        <ContainerContent>
            <div className={'paddDesc'}>
                <Block data-animch2 data-rel>
                    <div className={'wrapTitleNav'}>
                        <Link to={getUrl('home')} className="mytitle mainNavLink"
                            style={{ width: '100%' }}>
                            <BackBtn></BackBtn>
                            <SubjectName></SubjectName>
                        </Link>
                        <div className="brnsNextWrap" style={{ display: isMobile ? 'none' : 'block' }}>
                            <div className="text-right">
                                <button
                                    className={'btn btn2'}
                                    style={{
                                        opacity: canSubmitReport ? 1 : 0.5,
                                        cursor: canSubmitReport ? 'pointer' : 'not-allowed',
                                        pointerEvents: canSubmitReport ? 'auto' : 'none'
                                    }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (!fieldsVisible) {
                                            return;
                                        }
                                        if (!allRowsConfirmed) {
                                            alert(t('pleaseConfirmAllValuesBeforeSubmitting'));
                                            return;
                                        }
                                        if (!reportConsent) {
                                            alert('Please consent to processing your lab results to generate the report.');
                                            return;
                                        }
                                        const searchParams = new URLSearchParams(window.location.search);
                                        const paramsString = searchParams.toString();
                                        navigate(`/report${paramsString ? `?${paramsString}` : ''}`);
                                    }}
                                >
                                    {t('submitBloodTestResults')}
                                </button>
                            </div>
                        </div>
                    </div>
                    <Box>
                        <ModalMUI onClose={handleCloseModal} open={isModalOpen} data-modal-mui>
                            <AboutBiomarker
                                onClose={() => {
                                    console.log('qqqqq on Close about biomarker')
                                }}
                                indicator={selectedIndicator}
                                value={selectedIndicator?.value}
                            />
                        </ModalMUI>
                    </Box>
                    <section className="container dropzone-container">
                        {(!showDropzone) && !isFileProcessed && !fieldsVisible && !isProcessError && (
                            <PrivacyConsent
                                checked={privacyConsent}
                                onChange={setPrivacyConsent}
                            />
                        )}

                        {/* Dropzone - shown after delay */}
                        {showDropzone && (!isFileProcessed && !fieldsVisible && !isProcessError) && (() => {
                            const dropzoneProps = getRootProps({
                                className: `dropzone${isDragActive ? ' dropzone--active' : ''}`
                            })
                            const inputProps = getInputProps()
                            
                            if (promStatus?.due) {
                                return (
                                    <div
                                        onClick={() => setShowSurveyPrompt(true)}
                                        style={{ 
                                            opacity: (isUploading || isConverting) ? 0.5 : 1,
                                            cursor: 'pointer',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            minHeight: '200px',
                                            width: '100%'
                                        }}
                                    >
                                        <span className='dropzone-title'>{t('prom.completeSurveyFirst', 'Please complete survey first')}</span>
                                    </div>
                                )
                            }
                            
                            return (
                                <div {...dropzoneProps} style={{ opacity: (isUploading || isConverting) ? 0.5 : 1 }}>
                                    <input {...inputProps} />
                                    <ClipboardIcon className='dropzone-icon' />
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 16 }}>
                                        <span className='dropzone-title'>
                                            {isMobile ? t('selectFileOrTakePhoto') : t('selectFile')}
                                        </span>
                                        <span className='dropzone-description'>{t('onlyImagesOrPdfCanBeUploaded')}</span>
                                    </div>
                                </div>
                            )
                        })()}

                        {/* Overlay spinner */}
                        {(isUploading || isConverting) && (
                            <div className='dropzone-loading'>
                                <CircularProgress color="primary" style={{ color: "#3BAAB0" }} />
                                <div className='dropzone-loading-text'>{isConverting ? t('convertingPdf') || 'Converting PDF...' : t('uploadingAndProcessing')}</div>
                            </div>
                        )}

                        {/* Overlay success */}
                        {isFileProcessed && fieldsVisible && (
                            <div className='dropzone-success'>
                                <div style={{ marginBottom: 16 }}>
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                                        <circle cx="32" cy="32" r="32" fill="#3BAAB0" />
                                        <path d="M20 34L29 43L44 26" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div className='dropzone-success-text'>
                                    {t('imageUploadedAndProcessed')}
                                </div>
                                <button
                                    className="btn dropzone-success-button"
                                    onClick={handleResetUpload}
                                >
                                    {t('uploadAnotherFile')}
                                </button>
                            </div>
                        )}

                        {/* Overlay error if processing failed */}
                        {isProcessError && (
                            <div className='dropzone-error'>
                                <div style={{ marginBottom: 16 }}>
                                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                                        <circle cx="32" cy="32" r="32" fill="#d83f3d" />
                                        <path d="M22 22L42 42" stroke="white" strokeWidth="4" strokeLinecap="round" />
                                        <path d="M42 22L22 42" stroke="white" strokeWidth="4" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <div className='dropzone-error-text'>
                                    {t('failedToRecognizeInformation')}
                                </div>
                                <button
                                    className="btn dropzone-success-button"
                                    onClick={handleResetUpload}
                                >
                                    {t('uploadAnotherFile')}
                                </button>
                            </div>
                        )}
                    </section>

                    {!isFileProcessed && (
                        <div className="did-you-know" style={{ marginTop: '32px' }}>
                            <div className="did-you-know-title">{t('subjectForm.importantNote.title')}</div>
                            <div className="did-you-know-text">
                                {t('subjectForm.importantNote.text')}
                            </div>
                        </div>
                    )}


                    {/* Таблица с результатами только если файл обработан */}
                    {fieldsVisible && (
                        <div style={{ marginTop: 32 }} data-results-block>
                            <div className={'w100'} data-animch>
                                {(() => {
                                    const serverCount = _fields.filter((f: any) => !f.userAdded).length;
                                    const isPartial = uploadResult && serverCount < 19;
                                    const isFull = uploadResult && serverCount >= 19;
                                    const titleColor = !uploadResult ? '#d83f3d' : isPartial ? '#d83f3d' : undefined;
                                    const iconColor = !uploadResult ? '#d83f3d' : '#d83f3d';
                                    return (
                                        <>
                                            <div className="titleDescDark" style={!isFull ? { display: 'flex', alignItems: 'center', gap: '12px', color: titleColor } : {}}>
                                                {!isFull && (
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
                                                        <circle cx="12" cy="12" r="12" fill={iconColor} />
                                                        <path d="M12 8V12" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                                        <circle cx="12" cy="15.5" r="1" fill="white" />
                                                    </svg>
                                                )}
                                                {!uploadResult
                                                    ? t('fileNotReadableManualEntryRequired')
                                                    : isPartial
                                                        ? t('filePartiallyReadableManualEntryRequired') || 'File partially readable — manual entry required'
                                                        : t('pleaseReviewAllValuesCarefully')}
                                            </div>
                                            <div className="titleDesc2Black" style={{ marginTop: '8px', fontSize: '16px', margin: '10px 0px 0px 0px' }}>
                                                {!uploadResult
                                                    ? t('manualEntryRequiredDescription')
                                                    : isPartial
                                                        ? t('partialReadDescription') || 'Some biomarkers were not detected. Please fill in the missing values manually.'
                                                        : t('confirmEveryRowForAccuracy')}
                                            </div>
                                        </>
                                    );
                                })()}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '16px 0 8px 0', fontSize: '18px', fontWeight: 700 }}>
                                    <span style={{ color: 'rgb(255, 130, 0)' }}>{_fields.filter((f: any) => !f.userAdded).length}</span>
                                    <span style={{ color: '#999' }}>/</span>
                                    <span>19</span>
                                    <span style={{ fontWeight: 400, color: '#000' }}>{t('biomarkersFound') || 'Biomarkers found'}</span>
                                </div>
                                <div className={'table w100'}>
                                    <div className='table-head'>
                                        <div className='table-row-1'>{t('biomarker')}</div>
                                        <div className='table-row-2' style={{ display: 'none' }}>{t('unit')}</div>
                                        <div className='table-row-3'>{t('value')}</div>
                                        <div className='table-row-4'>{t('refLow')}</div>
                                        <div className='table-row-5'>{t('refHigh')}</div>
                                        <div className='table-row-6' style={{ fontWeight: '700', color: '#ff8200' }}>{t('confirm')}</div>
                                    </div>
                                    {_fields.length > 0 && _fields.map((it: any, ind: number) => (
                                        <div key={ind} className={'table-row rel '} data-animch="0" style={{ zIndex: 10000 - ind - 1 }}>
                                            <div className="table-row-1" style={it.userAdded && !biomarkerState.confirmedRows.has(it.indicatorId) ? { color: 'rgb(255, 130, 0)' } : {}}>
                                                {translateBiomarkerName(it.name, userBiomarkerOptions)}
                                            </div>
                                            <div className="table-row-2" data-rel style={{ display: 'none', zIndex: 100000 - ind }}>{it.unit || '—'}</div>
                                            <div className="table-row-3">
                                                <input
                                                    type="number"
                                                    style={{ width: '100%', ...(shouldHighlightInput(it) ? { border: '1.5px dashed rgb(255, 130, 0)', borderRadius: '4px' } : {}) }}
                                                    value={values[it.indicatorId] || ''}
                                                    placeholder={it.userAdded ? '' : '—'}
                                                    onChange={e => {
                                                        const newVal = e.target.value;
                                                        dispatch({ type: 'UPDATE_FIELD_VALUE', index: ind, value: newVal });
                                                        const newValues = { ...values, [it.indicatorId]: newVal };
                                                        setValues(newValues);

                                                        // Update the fields array for storage
                                                        const newFields = [..._fields];
                                                        newFields[ind] = { ...newFields[ind], value: newVal };
                                                        saveTableValuesToStorage(newFields, newValues);

                                                        try {
                                                            const key = 'biomarkers_data';
                                                            const existing = JSON.parse(localStorage.getItem(key) || '[]');
                                                            const updated = existing.map((b: any) => {
                                                                if (b.originalName === newFields[ind].name || b.nameEn === newFields[ind].name) {
                                                                    return {
                                                                        ...b,
                                                                        originalValue: newVal === '' ? null : Number(newVal),
                                                                        standardizedValue: newVal === '' ? null : Number(newVal)
                                                                    };
                                                                }
                                                                return b;
                                                            });
                                                            localStorage.setItem(key, JSON.stringify(updated));
                                                            console.log('Updated originalValue and standardizedValue in localStorage:', newVal);
                                                        } catch (e) {
                                                            console.error('Failed to update originalValue and standardizedValue in localStorage', e);
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="table-row-4">
                                                <input
                                                    type="number"
                                                    style={{ width: '100%', ...(shouldHighlightInput(it) ? { border: '1.5px dashed rgb(255, 130, 0)', borderRadius: '4px' } : {}) }}
                                                    value={it.labReferenceRange?.min ?? ''}
                                                    placeholder={it.userAdded ? '' : '—'}
                                                    onChange={e => {
                                                        const newMin = e.target.value;
                                                        dispatch({
                                                            type: 'UPDATE_FIELD_REF_RANGE',
                                                            index: ind,
                                                            range: { min: newMin === '' ? '' : Number(newMin) }
                                                        });

                                                        // Update the fields array for storage
                                                        const newFields = [..._fields];
                                                        const lr = { ...(newFields[ind].labReferenceRange || {}) };
                                                        lr.min = newMin === '' ? '' : Number(newMin);
                                                        newFields[ind] = { ...newFields[ind], labReferenceRange: lr };
                                                        saveTableValuesToStorage(newFields, values);

                                                        if (newFields[ind].userAdded) {
                                                            const biomarkerObj = generateUserBiomarkerObj(newFields[ind]);
                                                            // saveUserBiomarkerToStorage(biomarkerObj);
                                                            console.log('User biomarker object', biomarkerObj);
                                                        }
                                                        // Обновляем labReferenceRange в localStorage для всех строк
                                                        try {
                                                            const key = 'biomarkers_data';
                                                            const existing = JSON.parse(localStorage.getItem(key) || '[]');
                                                            const updated = existing.map((b: any) => {
                                                                if (b.originalName === newFields[ind].name || b.nameEn === newFields[ind].name) {
                                                                    return {
                                                                        ...b,
                                                                        labReferenceRange: {
                                                                            ...b.labReferenceRange,
                                                                            min: newMin === '' ? '' : Number(newMin)
                                                                        }
                                                                    };
                                                                }
                                                                return b;
                                                            });
                                                            localStorage.setItem(key, JSON.stringify(updated));
                                                            console.log('Updated labReferenceRange.min in localStorage');
                                                        } catch (e) {
                                                            console.error('Failed to update labReferenceRange in localStorage', e);
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="table-row-5">
                                                <input
                                                    type="number"
                                                    style={{ width: '100%', ...(shouldHighlightInput(it) ? { border: '1.5px dashed rgb(255, 130, 0)', borderRadius: '4px' } : {}) }}
                                                    value={it.labReferenceRange?.max ?? ''}
                                                    placeholder={it.userAdded ? '' : '—'}
                                                    onChange={e => {
                                                        const newMax = e.target.value;
                                                        dispatch({
                                                            type: 'UPDATE_FIELD_REF_RANGE',
                                                            index: ind,
                                                            range: { max: newMax === '' ? '' : Number(newMax) }
                                                        });

                                                        // Update the fields array for storage
                                                        const newFields = [..._fields];
                                                        const lr = { ...(newFields[ind].labReferenceRange || {}) };
                                                        lr.max = newMax === '' ? '' : Number(newMax);
                                                        newFields[ind] = { ...newFields[ind], labReferenceRange: lr };
                                                        saveTableValuesToStorage(newFields, values);

                                                        if (newFields[ind].userAdded) {
                                                            const biomarkerObj = generateUserBiomarkerObj(newFields[ind]);
                                                            // saveUserBiomarkerToStorage(biomarkerObj);
                                                            console.log('User biomarker object', biomarkerObj);
                                                        }
                                                        // Обновляем labReferenceRange в localStorage для всех строк
                                                        try {
                                                            const key = 'biomarkers_data';
                                                            const existing = JSON.parse(localStorage.getItem(key) || '[]');
                                                            const updated = existing.map((b: any) => {
                                                                if (b.originalName === newFields[ind].name || b.nameEn === newFields[ind].name) {
                                                                    return {
                                                                        ...b,
                                                                        labReferenceRange: {
                                                                            ...b.labReferenceRange,
                                                                            max: newMax === '' ? '' : Number(newMax)
                                                                        }
                                                                    };
                                                                }
                                                                return b;
                                                            });
                                                            localStorage.setItem(key, JSON.stringify(updated));
                                                            console.log('Updated labReferenceRange.max in localStorage');
                                                        } catch (e) {
                                                            console.error('Failed to update labReferenceRange in localStorage', e);
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="table-row-6">
                                                <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={biomarkerState.confirmedRows.has(it.indicatorId)}
                                                        onChange={(e) => handleRowConfirmation(it.indicatorId, e.target.checked)}
                                                        style={{
                                                            minWidth: '24px',
                                                            width: '16px',
                                                            height: '16px',
                                                            cursor: 'pointer',
                                                            appearance: 'none',
                                                            border: '2px solid #3BAAB0',
                                                            borderRadius: '2px',
                                                            backgroundColor: biomarkerState.confirmedRows.has(it.indicatorId) ? '#3BAAB0' : 'transparent',
                                                            position: 'relative'
                                                        }}
                                                        onMouseEnter={() => handleCheckboxHover(it.indicatorId)}
                                                        onMouseLeave={handleCheckboxLeave}
                                                    />
                                                    {biomarkerState.confirmedRows.has(it.indicatorId) && (
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            width: '15px',
                                                            height: '15px',
                                                            pointerEvents: 'none',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}>
                                                            <svg width="100%" height="100%" viewBox="0 0 8 8" fill="none">
                                                                <path d="M1 4L3 6L7 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                        </div>
                                                    )}
                                                    {showTooltip === it.indicatorId && (
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: '-40px',
                                                            left: '50%',
                                                            transform: 'translateX(-50%)',
                                                            background: '#333',
                                                            color: 'white',
                                                            padding: '4px 8px',
                                                            borderRadius: '4px',
                                                            fontSize: '12px',
                                                            whiteSpace: 'nowrap',
                                                            zIndex: 1000,
                                                            pointerEvents: 'none'
                                                        }}>
                                                            Please confirm all values before submitting.
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    <div style={{ width: 'auto', height: '1px', backgroundColor: '#EDEDED', margin: '10px 10px', boxSizing: 'border-box' }}></div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '24px 8px 16px' }}>
                                        <div style={{ position: 'relative', display: 'inline-flex' }}>
                                            <input
                                                type="checkbox"
                                                id="report-consent"
                                                checked={reportConsent}
                                                onChange={(e) => setReportConsent(e.target.checked)}
                                                style={{
                                                    minWidth: '24px',
                                                    width: '20px',
                                                    height: '20px',
                                                    cursor: 'pointer',
                                                    appearance: 'none',
                                                    border: '2px solid #3BAAB0',
                                                    borderRadius: '2px',
                                                    backgroundColor: reportConsent ? '#3BAAB0' : 'transparent',
                                                    position: 'relative'
                                                }}
                                            />
                                            {reportConsent && (
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    width: '15px',
                                                    height: '15px',
                                                    pointerEvents: 'none',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center'
                                                }}>
                                                    <svg width="100%" height="100%" viewBox="0 0 8 8" fill="none">
                                                        <path d="M1 4L3 6L7 2" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                            )}
                                        </div>
                                        <label htmlFor="report-consent" style={{ fontSize: '14px', fontWeight: 400, color: '#1a1a1a', cursor: 'pointer', userSelect: 'none' }}>
                                            {t('reportConsentText')}
                                        </label>
                                    </div>

                                    <div style={{ padding: '0 10px 10px 10px', display: 'flex', justifyContent: 'flex-end' }}>
                                        <button
                                            className={'btn btn2'}
                                            style={{
                                                opacity: canSubmitReport ? 1 : 0.5,
                                                cursor: canSubmitReport ? 'pointer' : 'not-allowed',
                                                pointerEvents: canSubmitReport ? 'auto' : 'none'
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (!fieldsVisible) {
                                                    return;
                                                }
                                                if (!allRowsConfirmed) {
                                                    alert(t('pleaseConfirmAllValuesBeforeSubmitting'));
                                                    return;
                                                }
                                                if (!reportConsent) {
                                                    alert('Please consent to processing your lab results to generate the report.');
                                                    return;
                                                }
                                                const allBiomarkers = collectAllBiomarkersData();
                                                localStorage.setItem('biomarkers_data', JSON.stringify(allBiomarkers));
                                                console.log('Saving all biomarkers before navigation:', allBiomarkers);
                                                saveUserBiomarkersToStorage();
                                                const searchParams = new URLSearchParams(window.location.search);
                                                const paramsString = searchParams.toString();
                                                navigate(`/report${paramsString ? `?${paramsString}` : ''}`);
                                            }}
                                        >
                                            {t('submitBloodTestResults')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {isEditorOpen && editorPortalTarget ? createPortal(
                        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}>
                            <div style={{ background: '#fff', borderRadius: 10, maxWidth: '90vw', maxHeight: '90vh', width: 'min(900px, 90vw)', padding: 16, display: 'flex', flexDirection: 'column', gap: 12, position: 'relative' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ fontWeight: 600, fontSize: 16 }}>{t('edit') || 'Edit'}</div>
                                    <button onClick={closeEditor} style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                                        <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4 4l8 8M12 4L4 12" stroke="#666" strokeWidth="1.5" strokeLinecap="round" />
                                        </svg>
                                    </button>
                                </div>
                                <div style={{ overflow: 'auto', border: '1px solid #EDEDED', borderRadius: 8, background: '#fafafa' }}>
                                    <canvas
                                        ref={editorCanvasRef}
                                        onMouseDown={onCanvasMouseDown}
                                        onMouseMove={onCanvasMouseMove}
                                        onMouseUp={onCanvasMouseUp}
                                        style={{ display: 'block', maxWidth: '100%', height: 'auto', cursor: 'crosshair' }}
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ color: '#666', fontSize: 12 }}>{t('selectAreasToHide') || 'Highlight areas you want to hide'}</div>
                                    <div style={{ display: 'flex', gap: 30 }}>
                                        <button className="btn" onClick={closeEditor}>{t('cancel') || 'Cancel'}</button>
                                        <div style={{ display: 'flex', gap: 8 }}>
                                            <button className="btn" onClick={resetEditorSelections} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                <CloseButton width={16} height={16} strokeWidth={1.6} />
                                                <span>{t('reset') || 'Reset'}</span>
                                            </button>
                                            <button className="btn" onClick={undoLastSelection} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                <UndoButton width={16} height={16} strokeWidth={1.6} />
                                                <span>{t('undo') || 'Undo'}</span>
                                            </button>
                                        </div>
                                        <button className="btn btn2" onClick={generateAndUploadPdf}>{t('continue') || 'Continue'}</button>
                                    </div>
                                </div>
                                {showPrivacyReminder && (
                                    <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.95)', borderRadius: 10, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', padding: 32, gap: 16 }}>
                                        <div style={{ fontSize: 28, fontWeight: 700, color: '#1a1a1a' }}>{t('protectYourPrivacy')}</div>
                                        <div style={{ fontSize: 16, color: '#444', lineHeight: '24px', maxWidth: 520 }}>
                                            {t('removePersonalDataBeforeAnalysis')}
                                            <br /><br />
                                            {t('drawBoxOverPersonalData')}
                                        </div>
                                        <button className="btn btn2" onClick={() => setShowPrivacyReminder(false)} style={{ minWidth: 120 }}>
                                            {t('ok') || 'OK'}
                                        </button>
                                    </div>
                                )}
                            </div>
                            <img src={editorImageUrl} alt="" onLoad={handleEditorImageLoad} style={{ display: 'none' }} />
                        </div>,
                        editorPortalTarget
                    ) : null}
                </Block>
            </div>

            {/* Fixed bottom button for mobile */}
            {isMobile && fieldsVisible && (
                <ActionFooter
                    canSubmitReport={canSubmitReport}
                    allRowsConfirmed={allRowsConfirmed}
                    reportConsent={reportConsent}
                    saveUserBiomarkersToStorage={saveUserBiomarkersToStorage}
                    collectAllBiomarkersData={collectAllBiomarkersData}
                    fieldsVisible={fieldsVisible}
                    isFileProcessed={isFileProcessed}
                    onGenerateAndUploadPdf={generateAndUploadPdf}
                />
            )}

            {/* Survey prompt popup */}
            {showSurveyPrompt && (
                <PromQuestionnaire open={showSurveyPrompt} onClose={() => setShowSurveyPrompt(false)} />
            )}
        </ContainerContent>
    )
}

export default Main
